export default __webpack_public_path__ + "static/media/affiliate-woman.5aef12c7.png";